import { gql } from '@apollo/client';
import { CommonLocalizableString } from 'network/common/cmsFragment';

import { fetchAllPage } from 'network/common/cmsUtils';

interface FetchBoothRootContentElementByIdQueryProps {
  boothId: string;
  locales: string[];
  hasProducts?: boolean;
  count?: number;
}

const fetchBoothTabsQuery = gql`
  query fetchBoothTabsQuery(
    $boothId: ID!
    $locales: [Locale!]!
    $cursor: String
    $count: Int
  ) {
    node(id: $boothId) {
      ... on Booth {
        id
        rootContentElement {
          tabs(first: $count, after: $cursor) {
            pageInfo {
              hasNextPage
              endCursor
            }
            nodes {
              id
              ... on BoothTabContentElement {
                title {
                  ...CommonLocalizableString
                }
              }
            }
          }
        }
      }
    }
  }
  ${CommonLocalizableString}
`;

const fetchBoothRootContentElementById = async (config: FetchBoothRootContentElementByIdQueryProps) => {
  const pages = await fetchAllPage(
    (data: any) => data.node.rootContentElement.tabs.pageInfo,
    fetchBoothTabsQuery,
    {
      ...config,
      count: config.count || 30,
    },
  );

  const tabs = pages
    .flatMap((page) => page.node.rootContentElement.tabs.nodes);

  const result = {
    id: pages[0].node.id,
    rootContentElement: { tabs: { nodes: tabs } },
  };

  return result;
};

export default fetchBoothRootContentElementById;
